import DateInput from '../../components/dateInput/DateInput';
import NavBar from './navbar/navBar';
import './addScheduleTemplate.scss';
import { ReactComponent as EllipseIcon } from '../../assets/icons/ellipse.svg';
import InputBox, { DropDown } from 'components/inputBox/inputBox';
import TripleToggleComponent from '../../components/tripleToggleComponent/tripleToggleComponent';
import { useState } from 'react';
import GreenRoundTick from '../../assets/icons/greenTickRound.png';
import WhiteTick from '../../assets/icons/whiteTick.png';
import WhiteTickRound from '../../assets/icons/whiteTickRound.png';
import redRoundWarning from '../../assets/icons/redRoundWarning.png';

import TimePicker from '../../components/timePicker/timePicker';
import WorkingDetailsCard from './workingDetailsCard/workingDetailsCard';

interface IEmployee {
  weeks: string;
  days: string;
  time: string;
  breakHours: string;
  hours: string;
  id: number;
}

const AddWorkScheduleTemplate = () => {
  const [selected, setSelected] = useState<number>(1);

  const [employees, setEmployees] = useState<IEmployee[]>([]);

  const addEmployee = () => {
    setEmployees([
      {
        id: 1,
        weeks: '1, 2, 3, 4주',
        days: '월, 화, 수, 목, 금',
        time: '09:00 ~ 18:00',
        breakHours: '휴식 60분 포',
        hours: '8시간',
      },
      {
        id: 2,
        weeks: '1주',
        days: '월, 화, 수, 목, 금',
        time: '09:00 ~ 18:00',
        breakHours: '휴식 없음',
        hours: '4.5시간',
      },
    ]);
  };

  const removeEmployee = (id: number) => {
    setEmployees(employees.filter((item: IEmployee) => item.id != id));
  };

  return (
    <>
      <NavBar />
      <div className="addWorkScheduleTemplateScreen">
        <div className="container">
          <div className="nameContainer">
            <div className="heading">일정템플릿 추가</div>
            <div className="subHeading">템플릿 정보를 입력해주세요.</div>
          </div>

          <div className="basicInfoCard">
            <div className="leftContainer">
              <div className="title">템플릿 정보</div>

              <InputBox value={'템플릿명 입력'} label={'템플릿명*'} />

              <div className="toggleWrapper">
                <TripleToggleComponent
                  label="일하는 방식"
                  getSelected={(e) => {
                    setSelected(e);
                  }}
                />
              </div>

              {selected !== 3 ? (
                <div className="dateInputWrapper">
                  <div className="labelRow ">
                    <div className="icon">
                      <EllipseIcon />
                    </div>

                    <div className="labelText ">반복기간</div>
                  </div>

                  <div className="dates">
                    <DateInput title="시작일 선택" />
                    <DateInput title="퇴사일" hasDisabled rightTight />
                  </div>
                </div>
              ) : (
                <></>
              )}

              {selected === 1 ? (
                <>
                  <div className="dateInputDropDownWrapper">
                    <div className="labelRow ">
                      <div className="icon">
                        <EllipseIcon />
                      </div>

                      <div className="labelText ">근무 요일</div>
                    </div>

                    <div className="dates">
                      <DropDown options={['월, 화, 수, 목, 금']} fullWidth />
                    </div>
                  </div>

                  <div className="timeInputDropDownWrapper">
                    <div className="labelRow ">
                      <div className="icon">
                        <EllipseIcon />
                      </div>

                      <div className="labelText ">근무 시간</div>
                    </div>

                    <div className="dates">
                      <div className="timeHalf">
                        <TimePicker setData={() => {}} />
                      </div>
                      <div className="dropDownSelection">
                        <DropDown options={['휴식 60분 포함']} fullWidth />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}

              <div hidden={selected != 2} className="secondConditionalComponent">
                <div className="divider">
                  <div className="labelRow ">
                    <div className="icon">
                      <EllipseIcon />
                    </div>

                    <div className="labelText ">반복일정</div>
                  </div>
                  <div className="line" />
                </div>

                <div className="grayContainer">
                  <div className="labels">
                    <div className="row">
                      <div className="imageWrapper">
                        <img src={WhiteTick} className="image" alt="" />
                      </div>
                      <div className="textLabel">근무 주</div>
                      <img src={WhiteTickRound} className="whiteTickImage" alt="" />
                    </div>

                    <div className="row secondRow">
                      <div className="imageWrapper">
                        <img src={WhiteTick} className="image" alt="" />
                      </div>
                      <div className="text">근무 요일</div>
                    </div>

                    <div className="row thirdRow">
                      <div className="imageWrapper">
                        <img src={WhiteTick} className="image" alt="" />
                      </div>
                      <div className="textLabel">근무 시간</div>
                    </div>
                  </div>
                  <div className="controllers">
                    <DropDown options={['근무 주 선택']} />
                    <DropDown options={['근무 요일 선택']} />
                    <div className="halfRow">
                      <div className="half">
                        <TimePicker setData={() => {}} />
                      </div>
                      <div className="half dropDownRight">
                        <DropDown options={['휴식 60분 포함']} />
                      </div>
                    </div>
                    <div
                      className="greenButton"
                      onClick={() => {
                        addEmployee();
                      }}>
                      + 반복 일정 추가
                    </div>
                  </div>
                </div>

                {employees.map((employee) => {
                  return (
                    <WorkingDetailsCard
                      id={employee.id}
                      weeks={employee.weeks}
                      days={employee.days}
                      time={employee.time}
                      breakHours={employee.breakHours}
                      hours={employee.hours}
                      onClose={() => {
                        removeEmployee(employee.id);
                      }}
                    />
                  );
                })}
              </div>

              <div
                className={employees.length == 2 ? 'hourContainerWrapperRed' : 'hourContainerWrapper'}
                hidden={selected === 3}>
                <div className="divider">
                  <div className="labelRow ">
                    <div className="icon">
                      <EllipseIcon />
                    </div>

                    <div className="labelText ">총 근무 시간</div>
                  </div>
                  <div className="line" />
                </div>
                <div className="hourContainer">
                  <div className="leftContainerText">{selected === 1 ? '주 52시간' : '주 평균 0시간'}</div>
                  <div className="rightContainerText">
                    {employees.length == 2 ? (
                      <img src={redRoundWarning} alt="" className="warning" />
                    ) : (
                      <img src={GreenRoundTick} alt="" className="tick" />
                    )}
                    적합한 설정입니다
                  </div>
                </div>
              </div>
            </div>
            <div className="rightContainer">
              <div className="title">일정템플릿이란?</div>
              <div className="description">
                직원 일정 정보를 템플릿으로 저장해두면 여러 명의 <br />
                직원에게 일정 정보를 한꺼번에 적용할 수 있어요
              </div>
              <div className="secondTitle">일하는 방식</div>
              <div className="description">
                고정: 출퇴근 시간이 고정되어있어요 <br />
                선택적 : 출퇴근 시간을 자유롭게 선택할 수 있어요 <br />
                자율출퇴근 : 근무일정 없이 직원이 출퇴근을 기록해요
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddWorkScheduleTemplate;
